import { defaultCountries, emailRegex, languageCode } from './Contansts'

export const downloadDocument = async (fileName, url) => {
  try {
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const docUrl = BASE_URL + url
    const response = await fetch(docUrl)
    if (!response.ok) {
      throw new Error('Failed to load resource')
    }
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Error downloading the file:', error)
  }
}

export const viewDocument = (url) => {
  window.open(process.env.REACT_APP_BASE_URL + url, '_blank')
}

export const getImageUrl = (image) => {
  const url = image?.url || '/'
  const BASE_URL = process.env.REACT_APP_BASE_URL
  return BASE_URL + url
}

export const getUrl = (image) => {
  const url = image?.url || '/'
  const BASE_URL = process.env.REACT_APP_BASE_URL
  return BASE_URL + url
}

export const scrollElemToTop = (offsetTop = 1) => {
  if (offsetTop) {
    window.scrollTo({
      top: -90 + offsetTop,
      behavior: 'smooth',
    })
  }
}

export const getTotalPages = (pagination) => {
  const total_items = Number(pagination?.total || 1)
  const items_display = Number(pagination?.limit || 1)
  const numOfPage = Math.ceil(total_items / items_display)
  return numOfPage
}

export const updateClassname = (action, element, classname) => {
  if (action === 'add') {
    if (element?.classList?.contains(classname)) return
    else {
      element?.classList?.add(classname)
    }
  }
  if (action === 'remove') {
    if (!element?.classList?.contains(classname)) return
    else {
      element?.classList?.remove(classname)
    }
  }
}

// Function to check if a specific cookie exists
export const checkCookie = (name) => {
  // const cookies = document.cookie.split(';')

  // for (const cookie of cookies) {
  //   const trimmedCookie = cookie.trim()
  //   if (trimmedCookie.startsWith(`${name}=`)) {
  //     return true
  //   }
  // }
  if (localStorage.getItem(name)) {
    return true
  }
  return false
}

// Function to set a cookie
export const setCookie = (name, value, days) => {
  // let expires = ''
  // if (days) {
  // const date = new Date()
  // date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  // expires = `;expires=${date.toUTCString()}`
  // }

  // const cookieType = `Secure;SameSite=Strict`
  // document.cookie = `${name}=${value || ''}${expires};path=/;${cookieType}`
  localStorage.setItem(name, value)
}

export const validateEmail = (email = '') => {
  if (email === '') {
    return true
  }

  // Length Check
  if (email.length > 254) {
    return true
  }

  // Format and Syntax Check
  if (!emailRegex.test(email)) {
    return true
  }

  return false
}

function getDefaultCountry(languageCode) {
  return defaultCountries[languageCode] || 'US' // Default to 'US' if not found
}

export function formatDate(inputDate = '', languageCode = 'en') {
  const locale = languageCode.includes('-')
    ? languageCode
    : `${languageCode}-${getDefaultCountry(languageCode)}`

  const [day, month, year] = inputDate?.split('/')
  if (day && month && year) {
    const date = new Date(year, month - 1, day)

    return new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(date)
  }
  return ''
}

export function getDaysInMonth(month, year) {
  // Convert the month from MMM to a number (0-11)
  const monthIndex = new Date(`${month} 1, ${year}`).getMonth()

  // Create a new Date object set to the first day of the next month
  const nextMonth = new Date(year, monthIndex + 1, 1)

  // Subtract one day to get the last day of the given month
  nextMonth.setDate(nextMonth.getDate() - 1)

  // Return the day of the month which is the last day
  return nextMonth.getDate()
}

export function getCurrentMonthYearFormatted() {
  const now = new Date()
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'short', // 'Jan', 'Feb', etc.
    year: 'numeric', // '2024'
  })
  return formatter.format(now)
}

// Check if a specific `MMM YYYY` is present in the current year
export function isMonthYearPresent(target) {
  const currentMonthYear = getCurrentMonthYearFormatted()
  return currentMonthYear === target
}

export function getDaysFromStartOfMonth() {
  const now = new Date()
  return now.getDate() // Current day of the month
}

export const isArabic = (code) => {
  return code === languageCode?.ARABIC
}

export function reorderArray(targetArr) {
  if (targetArr && targetArr?.length > 0) {
    const reorderedArr = targetArr?.sort((a, b) => a.order - b.order)
    return reorderedArr
  } else return []
}

export const isLanguage = (code) => {
  const isDefault = code === languageCode.ENGLISH
  const isSpanish = code === languageCode.SPANISH
  const isFrench = code === languageCode.FRENCH

  return { isDefault, isSpanish, isFrench }
}
